// combatpro/panels/monsters/MonsterResults.js
//
// Combat PRO - MonsterResults (decomposition of MonsterPanel.js).
//
// Static markup only, moved verbatim from MonsterPanel.js: the searchResults
// container (the last child of the search-section). Its id and class name are
// preserved exactly. It is an empty mount in the source and remains empty here.
// No state, hooks, logic, searching, or filtering. Imports only React. Do not
// edit battletracker.html.

import React from 'react';

function MonsterResults() {
  return (
    <div id="searchResults" className="vi-search-results"></div>
  );
}

export default MonsterResults;
